import { selectSelectedOrder } from './selected-order/selected-order.selectors';

export const orderSelectors = {
  selectSelectedOrder,
};
